module.exports = __webpack_public_path__ + "static/aboutUs-253c3d79ffe3e4e7efed25e280d80e64.jpg";